import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { task } from 'src/app/utils/filterDropDownData';
import { helperService } from 'src/app/utils/helper';
import { FieldInfo, FieldInfoGridService } from '../field-info-grid/field-info-grid.service';

@Component({
    selector: 'tasks-grid-view',
    templateUrl: './tasks-grid-view.component.html',
    styleUrls: ['./tasks-grid-view.component.scss'],
    standalone: false
})
export class TasksGridViewComponent implements OnInit {
  // v13-migration placeholder (Ivy basic template-check requires the symbol to exist; undefined at runtime == v12 behaviour; Phase 2: align template)
  submitted: any;
  lpcdashboard: any;
  onlytk: any;
  dueDateError: any;
  dueDateExceeded: any;
  enableDeleteTask: any;
  enableReassignTask: any;

  @Input()
  taskAssignDialog: boolean = false;
  
  @Input()
  viewOnly: boolean = true;

  @Input()
  selectedRow: any;

  @Input()
  userTkPracticeAreas: any[] = [];

  @Input()
  reviewstatuslist: any[] = [];

  @Input()
  stateCodeMapList: any[] = [];

  @Input()
  canadaStateList: any[] = [];

  @Input()
  defaultTime:Date=new Date();

  @Input()
  lpcUsersList: any[] = [];

  taskForm: any = [];

  showCountry: any = false;
  showStateCode: any = false;
  showQuantityState: any = false;

  constructor(
    private filterService: helperService,
    private datePipe: DatePipe,private fieldInfoService: FieldInfoGridService) { }

  ngOnInit(): void {
    this.taskForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      taskName: new UntypedFormControl(''),
      projectName: new UntypedFormControl(''),
      orgName: new UntypedFormControl(''),
      matterName: new UntypedFormControl(''),
      qbTaskId: new UntypedFormControl(''),
      description: new UntypedFormControl(''),
      descriptionTypeCode: new UntypedFormControl(''),
      timeEstimate: new UntypedFormControl('', [Validators.required]),
      actualTime: new UntypedFormControl(''),
      isEnforceMaximum: new UntypedFormControl(''),
      stateCode: new UntypedFormControl('', [Validators.required]),
      country: new UntypedFormControl('', [Validators.required]),
      isCompleted: new UntypedFormControl('', [Validators.required]),
      projTaskAssignmentStatus: new UntypedFormControl(''),
      isBillable: new UntypedFormControl('', [Validators.required]),
      consolidatedTimeRecords: new UntypedFormControl('', [Validators.required]),
      isRequireEstimate: new UntypedFormControl('', [Validators.required]),
      statusCode: new UntypedFormControl('', [Validators.required]),
      isApprovalRequired: new UntypedFormControl('', [Validators.required]),
      taskDueDate: new UntypedFormControl('', [Validators.required]),
      projectDueDate: new UntypedFormControl(''),
      openEnded: new UntypedFormControl('', [Validators.required]),
      quantityState: new UntypedFormControl([]),
      quantityNumber: new UntypedFormControl(''),
      maxTime: new UntypedFormControl(''),
      rateTypeCode: new UntypedFormControl(''),
      isStateRelated: new UntypedFormControl(''),
      stateDesc: new UntypedFormControl(''),
      // stateCode:new FormControl(''),
      countryRelated: new UntypedFormControl(''),
      createdOn: new UntypedFormControl(''),
      createdBy: new UntypedFormControl(''),
      dueDaySlot: new UntypedFormControl(''),
      tkRating: new UntypedFormControl(''),
      quantityType: new UntypedFormControl(''),
      holdTimeUntilComp: new UntypedFormControl('', [Validators.required]),
      approver: new UntypedFormControl('', [Validators.required]),
      approved: new UntypedFormControl(''),
      timeRecordsLoggedTime: new UntypedFormControl(''),
      includeToday: new UntypedFormControl(''),
      projTaskAssignmentTkId: new UntypedFormControl(''),
      projTaskAssignmentUsername: new UntypedFormControl(''),
      quantityRelated: new UntypedFormControl(''),
      progress: new UntypedFormControl(''),
      reviewStatus: new UntypedFormControl(''),
      practiceAreaCode: new UntypedFormControl(''),
      notes: new UntypedFormControl(''),
      driveLink: new UntypedFormControl(''),
      nonBillableReason: new UntypedFormControl(''),
    });
    // this.selectedRow.taskDueDate = this.datePipe.transform(this.selectedRow.taskDueDate, "MM/dd/yyyy");
    if (this.selectedRow.quantityType == "State") {
      this.showQuantityState = true;
      this.selectedRow.quantityState = this.selectedRow.quantityState ? this.selectedRow.quantityState.map((obj: any) => obj.stateCode) : [];
    } else {
      this.showQuantityState = false;
    }
    if (this.selectedRow.isStateRelated != "Yes") {
      this.taskForm.controls['stateCode'].disable()
      this.showStateCode = false;
    }
    if (this.selectedRow.countryRelated != "Yes") {
      this.taskForm.controls['country'].disable()
      this.showCountry = false;
    }
    this.taskForm.patchValue(this.selectedRow);
    this.taskForm.controls['timeEstimate'].value = this.filterService.convertTimeNumToStr(this.selectedRow.timeEstimate);
    this.taskForm.controls['maxTime'].value = this.filterService.convertTimeNumToStr(this.selectedRow.maxTime);
    this.taskForm.disable();
    
  }

  
  get timeEstimate() {
    return this.taskForm.get('timeEstimate');
  }
  get actualTime() {
    return this.taskForm.get('actualTime');
  }
  get stateCode() {
    return this.taskForm.get('stateCode');
  }
  get country() {
    return this.taskForm.get('country');
  }
  get consolidatedTimeRecords() {
    return this.taskForm.get('consolidatedTimeRecords');
  }
  get statusCode() {
    return this.taskForm.get('statusCode');
  }
  get quantityState() {
    return this.taskForm.get('quantityState');
  }
  get quantityNumber() {
    return this.taskForm.get('quantityNumber');
  }
  get approver() {
    return this.taskForm.get('approver');
  }
  get openEnded() {
    return this.taskForm.get('openEnded');
  }
  get approved() {
    return this.taskForm.get('approved');
  }
  get holdTimeUntilComp() {
    return this.taskForm.get('holdTimeUntilComp');
  }
  get quantityRelated() {
    return this.taskForm.get('quantityRelated');
  }
  get quantityType() {
    return this.taskForm.get('quantityType');
  }
  get isApprovalRequired() {
    return this.taskForm.get('isApprovalRequired');
  }
  get taskDueDate() {
    return this.taskForm.get('taskDueDate');
  }
  get isRequireEstimate() {
    return this.taskForm.get('isRequireEstimate');
  }
  get isBillable() {
    return this.taskForm.get('isBillable');
  }
  get isCompleted() {
    return this.taskForm.get('isCompleted');
  }
  get practiceAreaCode() {
    return this.taskForm.get('practiceAreaCode');
  }
  get tkRating() {
    return this.taskForm.get('tkRating');
  }
  get nonBillableReason() {
    return this.taskForm.get('nonBillableReason');
  }

  getFieldInfo(fieldKey: string): FieldInfo | undefined {
    return this.fieldInfoService.getAllFields().find((f: FieldInfo) => f.gridName === 'Project Task' && f.fieldKeyName === fieldKey);
  }
}
